<template>
    <div class="fixed inset-0 bg-white z-30 flex-col">
        <!-- close button -->
        <div
            class="
                fixed
                top-0
                right-0
                bg-primary
                p-1
                z-40
                text-4xl text-white
                flex
                justify-center
            "
            @click="close"
        >
            <i class="icon-np-cancel"></i>
        </div>

        <!-- content -->
        <div class="overflow-scroll py-4 px-8 h-5/6">
            <!-- title -->
            <div class="text-2xl text-primary font-medium mb-4">
                Filter Inventory
            </div>

            <!-- price -->
            <div class="mb-8 border-b">
                <div :class="titleClasses">Vehicle Price</div>
                <slider-component
                    class="px-4 pb-4"
                    v-model="filter.price"
                    @change="updatePrice"
                    :min="minPrice"
                    :max="maxPrice"
                    :step="5"
                    :format="{ prefix: '$', suffix: 'K' }"
                />
            </div>

            <!-- mileage -->
            <div class="mb-8 border-b">
                <div :class="titleClasses">Mileage</div>
                <slider-component
                    class="px-4 pb-4"
                    v-model="filter.mileage"
                    @change="updateMileage"
                    :min="10"
                    :max="maxMileage"
                    :step="10"
                    :format="{ suffix: 'k' }"
                />
            </div>

            <!-- model year -->
            <div class="mb-8 border-b">
                <div :class="titleClasses">Model Year</div>
                <slider-component
                    class="px-4 pb-4"
                    v-model="filter.year"
                    @change="updateYear"
                    :min="minYear"
                    :max="maxYear"
                />
            </div>

            <!-- make -->
            <div class="mb-8 border-b">
                <div :class="titleClasses">Make</div>

                <div
                    v-for="make in makes"
                    :key="make"
                    :class="wrapperClasses"
                    @click="updateMake(make)"
                >
                    <checkbox-component
                        :name="make"
                        :checked="isSelectedMake(make)"
                    />
                    {{ make }}
                </div>
            </div>

            <!-- location -->
            <div class="mb-8 border-b">
                <div :class="titleClasses">Location</div>

                <div
                    v-for="auction in auctions"
                    :key="auction"
                    :class="wrapperClasses"
                    @click="updateAuction(auction)"
                >
                    <checkbox-component
                        :name="auction"
                        :checked="isSelectedAuction(auction)"
                    />
                    {{ auction }}
                </div>
                <div
                    v-for="location in compounds"
                    :key="location.division"
                    :class="wrapperClasses"
                    @click="updateCompound(location.division)"
                >
                    <checkbox-component
                        :name="location.division"
                        :checked="isSelectedCompound(location.division)"
                    />
                    {{
                        location.selling_location_city +
                        ", " +
                        location.selling_location_state
                    }}
                </div>
            </div>
        </div>

        <!-- footer -->
        <div class="bg-gray-100 flex items-center px-8 h-1/6">
            <div
                class="text-primary text-sm tracking-wide flex-grow"
                @click="initializeFilter"
            >
                <i class="icon-np-cancel"></i>
                Clear All Filters
            </div>
            <div
                class="
                    py-2
                    w-40
                    flex
                    justify-center
                    rounded-full
                    text-sm text-secondary-light text-white
                    font-semibold
                    tracking-wide
                    bg-primary
                "
                @click="fetchVehicles"
            >
                Apply
            </div>
        </div>
    </div>
</template>

<script>
import SliderComponent from "@/Components/Slider";
import CheckboxComponent from "@/Components/Checkbox";

export default {
    components: {
        SliderComponent,
        CheckboxComponent,
    },
    data() {
        return {
            titleClasses: [
                "text-xl",
                "font-medium",
                "text-secondary",
                "tracking-wide",
                "my-4",
            ],
            wrapperClasses: [
                "my-3",
                "mr-4",
                "flex",
                "items-center",
                "text-gray-500",
                "text-sm",
            ],
            filter: {
                price: [],
                mileage: 0,
                year: [],
                make: [],
                auction: [],
                compound: [],
            },
        };
    },
    mounted() {
        // set filter
        this.initializeFilter();

        if (this.originalFilter) {
            if (this.originalFilter.hasOwnProperty("price")) {
                this.filter.price = this.originalFilter.price.map((price) =>
                    parseInt(price)
                );
            }

            if (this.originalFilter.hasOwnProperty("mileage")) {
                this.filter.mileage = parseInt(this.originalFilter.mileage);
            }

            if (this.originalFilter.hasOwnProperty("year")) {
                this.filter.year = this.originalFilter.year.map((year) =>
                    parseInt(year)
                );
            }

            if (this.originalFilter.hasOwnProperty("make")) {
                this.filter.make = this.originalFilter.make;
            }

            if (this.originalFilter.hasOwnProperty("auction")) {
                this.filter.auction = this.originalFilter.auction;
            }

            if (this.originalFilter.hasOwnProperty("compound")) {
                this.filter.compound = this.originalFilter.compound;
            }
        }
    },
    methods: {
        initializeFilter() {
            this.filter.price = [this.minPrice, this.maxPrice];
            this.filter.mileage = this.maxMileage;
            this.filter.year = [this.minYear, this.maxYear];
            this.filter.make = [];
            this.filter.auction = [];
            this.filter.compound = [];
        },
        isSelectedMake(make) {
            return this.filter.make.includes(make);
        },
        isSelectedAuction(auction) {
            return this.filter.auction.includes(auction);
        },
        isSelectedCompound(location) {
            return this.filter.compound.includes(location);
        },
        updatePrice(range) {
            this.filter.price = range;
        },
        updateMileage(mileage) {
            this.filter.mileage = mileage;
        },
        updateYear(range) {
            this.filter.year = range;
        },
        updateMake(make) {
            const index = this.filter.make.indexOf(make);
            if (index > -1) {
                this.filter.make.splice(index, 1);
            } else {
                this.filter.make.push(make);
            }
        },
        updateAuction(auction) {
            const index = this.filter.auction.indexOf(auction);
            if (index > -1) {
                this.filter.auction.splice(index, 1);
            } else {
                this.filter.auction.push(auction);
            }
        },
        updateCompound(location) {
            const index = this.filter.compound.indexOf(location);
            if (index > -1) {
                this.filter.compound.splice(index, 1);
            } else {
                this.filter.compound.push(location);
            }
        },
        fetchVehicles() {
            let result = {};

            if (
                this.filter.price.length > 0 &&
                !(
                    this.filter.price[0] === this.minPrice &&
                    this.filter.price[1] === this.maxPrice
                )
            ) {
                result.price = this.filter.price;
            }

            if (this.filter.mileage < this.maxMileage) {
                result.mileage = this.filter.mileage;
            }

            if (
                this.filter.year.length > 0 &&
                !(
                    this.filter.year[0] === this.minYear &&
                    this.filter.year[1] === this.maxYear
                )
            ) {
                result.year = this.filter.year;
            }

            if (this.filter.make.length > 0) {
                result.make = this.filter.make;
            }

            if (this.filter.auction.length > 0) {
                result.auction = this.filter.auction;
            }

            if (this.filter.compound.length > 0) {
                result.compound = this.filter.compound;
            }

            this.$emit("filter", result);
            this.close();
        },
        close() {
            this.$emit("close");
        },
    },
    props: {
        makes: {
            type: Array,
            default: null,
        },
        auctions: {
            type: Array,
            default: null,
        },
        compounds: {
            type: Array,
            default: null,
        },
        minPrice: {
            type: Number,
            default: 0,
        },
        maxPrice: {
            type: Number,
            default: 100,
        },
        maxMileage: {
            type: Number,
            default: 100,
        },
        minYear: {
            type: Number,
        },
        maxYear: {
            type: Number,
        },
        originalFilter: {
            type: Object,
            default: null,
        },
    },
};
</script>
